import PropTypes from 'prop-types';
// @mui
import { Box, Stack, Typography, Avatar } from '@mui/material';
// components
import Iconify from '../../components/Iconify';

const COLOR_GRAY = '#E6E6E6';
const LINK_COLOR = '#0275B5';
const FONT_MERRIWEATHER = '"Merriweather",serif';

const websiteContents3URL = "https://charityph-website-content.s3.ap-southeast-1.amazonaws.com/";
const projectImagess3URL = "https://charity-project-images.s3.ap-southeast-1.amazonaws.com";

CharityProfile.propTypes = {
  // charity: PropTypes.shape({
  //   charityDetails: PropTypes.shape({
  //     initials: PropTypes.string,
  //     icon: PropTypes.string,
  //     name: PropTypes.string,
  //   }),
  // }),
  charity: PropTypes.object,
};

export default function CharityProfile({ charity }) {  
  const { organization } = charity; 
  const logo = charity.charityDetails?.logo; 
  const img = logo?.includes('https') ? logo : logo?.includes('images/charities') ? websiteContents3URL + logo : projectImagess3URL + logo; // eslint-disable-line no-nested-ternary

  return (
    <Stack direction={'row'} width={1} spacing={5} alignItems={'flex-start'}>
      {/* <Avatar
        src={s3URL + logo}
        alt={name}
        sx={{
          bgcolor: COLOR_GRAY,
          width: { xs: 70, md: 120 },
          height: { xs: 70, md: 120 },
          mr: { md: 1 },
          fontSize: { xs: 20, md: 30 },
          boxShadow: 2,
        }}
      >
        {name.substring(0, 1)}
      </Avatar> */}
      <img src={img} alt={organization} width="100" height="100" style={{borderRadius: 5}} />
      <Box display={'flex'} flexDirection={'column'}>
        <Typography sx={{ fontFamily: FONT_MERRIWEATHER, typography: { xs: 'h4', md: 'h3' } }}>{organization}</Typography>
        {/* <Box mt={1}>
          <Iconify icon={'mdi:charity'} sx={{ color: LINK_COLOR, width: 45, height: 45 }} />
          <Iconify icon={'icon-park-solid:love-and-help'} sx={{ color: LINK_COLOR, width: 45, height: 45 }} />
        </Box> */}
      </Box>
    </Stack>
  );
}